import { root } from "src/root";
import { COURSES_LIMIT } from "src/constants/common";
import { CoursesList } from "@services/api/courses/typedef";

const instructorPublicApi = root.domain("instructor-public");

export const $instructorId = instructorPublicApi.store<number | null>(null);
export const $limit = instructorPublicApi.store(COURSES_LIMIT);
export const $instructorCourses = instructorPublicApi.store<CoursesList | null>(null);

export const setInstructorId = instructorPublicApi.event<number | null>();

export const setLimit = instructorPublicApi.event<number>();
export const clearLimit = instructorPublicApi.event();
